import React from "react";
import { Spinner } from "react-bootstrap";

export function SpinnerGroup() {
   return (
      <>
         <Spinner className="m-1 " size="sm" animation="grow" style={{ animationDelay: "0s" }}></Spinner>
         <Spinner className="m-1 " size="sm" animation="grow" style={{ animationDelay: "0.2s" }}></Spinner>
         <Spinner className="m-1 " size="sm" animation="grow" style={{ animationDelay: "0.4s" }}></Spinner>
      </>
   );
}
